import apiClient from '@/services/axios'

class CollectionsService {
  async getCollections(page, perPage, search) {
    const searchParams = new URLSearchParams()
    searchParams.append('page', page)
    searchParams.append('per_page', perPage)
    searchParams.append('search', search)

    const url = `/admin/unified-collections?${searchParams}`
    return apiClient.get(url)
  }

  async getCollection(collectionId) {
    const url = `/admin/unified-collections/${collectionId}`
    return apiClient.get(url)
  }

  async createCollection(data) {
    const url = '/admin/unified-collections'
    return apiClient.post(url, data)
  }

  async updateCollection(collectionId, data) {
    const url = `/admin/unified-collections/${collectionId}`
    return apiClient.put(url, data)
  }

  async toggleCollectionActivity(collectionId) {
    const url = `/admin/unified-collections/${collectionId}/toggle-active`
    return apiClient.patch(url)
  }

  async deleteCollection(collectionId) {
    const url = `/admin/unified-collections/${collectionId}`
    return apiClient.delete(url)
  }

  async getCollectionItems(page, perPage, search, collectionId) {
    const searchParams = new URLSearchParams()
    searchParams.append('page', page)
    searchParams.append('per_page', perPage)
    searchParams.append('search', search)

    const url = `/admin/unified-collections/${collectionId}/items?${searchParams}`
    return apiClient.get(url)
  }

  async createCollectionItem(collectionId, data) {
    const url = `/admin/unified-collections/${collectionId}/items`
    return apiClient.post(url, data)
  }

  async uploadCollectionItems(file, collectionId) {
    const formData = new FormData()
    formData.append('file', file)
    const url = `/admin/unified-collections/${collectionId}/items/import`
    return apiClient.post(url, formData)
  }

  async deleteCollectionItems(collectionId, item_ids) {
    const url = `/admin/unified-collections/${collectionId}/items`
    return apiClient.delete(url, {
      params: { item_ids },
    })
  }
}
export default new CollectionsService()
